<template>
    <form>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Table Settings</p>
            </header>

            <section class="modal-card-body">
                <div>Choose which table columns to display and specify their order by dragging</div>

                <form-error :error="getError('columns')" />

                <draggable v-model="orderedColumns" :options="{group: 'columns'}" style="min-height: 100%">
                  <template #item="{element}">
                    <div class="btn-group btn-group-toggle" style="display:block;" data-toggle="buttons">
                        <label class="btn btn-primary" style="width: 100%;">
                          <input type="checkbox" :name="columnLabelByField(element)" v-model="visibleColumns" :value="element" autocomplete="off"> {{ columnLabelByField(element) }}
                        </label>
                    </div>
                  </template>
                </draggable>
            </section>

            <footer class="modal-card-foot">
                <button class="button" type="button" @click.prevent="$parent.$parent.$emit('update:active', false)">Close</button>
                <button v-if="userSettings" class="button is-warning" @click.prevent="handleReset">Reset</button>

                <button class="button is-primary" @click.prevent="handleUpdate">Save</button>
            </footer>
        </div>
    </form>
</template>

<script>
    import HandlesForm from '../../mixins/HandlesForm'
    import { mapActions, mapGetters } from 'vuex'
    import Draggable from 'vuedraggable/src/vuedraggable'

    export default {
        mixins: [HandlesForm],

        components: {
            Draggable
        },

        props: {
            availableColumns: {
                type: Array,
                default(){ return [] },
            },
            customColumns: {
                type: Array,
                default(){ return [] },
            },
            slug: {
                type: String,
                required: true
            },
        },

        data () {
            return {
                orderedColumns: [],
                visibleColumns: [],
                initialVisibleColumns: null
            }
        },

        mounted () {
            let allColumns = this.availableColumns.length ? this.availableColumns : this.allTableColumnsBySlug(this.slug)
            const userColumnsField =  _.map(this.userColumns, 'field')
            this.visibleColumns = userColumnsField.length ? userColumnsField : _.map(this.allColumns, 'field')
            this.orderedColumns = _.union(
                this.visibleColumns,
                _.without(_.map(allColumns, 'field'))
            )
        },

        methods: {
            ...mapActions({
                update: 'updateTableSetting',
                remove: 'removeTableSetting',
            }),

            handleReset() {
                this.wrapSubmit(this.remove)(this.userSettings)
                    .then(res => {
                        this.successMessage('Operation successfull')
                        this.$parent.$parent.$emit('update:active', false)
                        this.$emit('table-settings-changed')
                        return res
                    })
            },

            handleUpdate() {
                let submit = this.wrapSubmit(this.update),
                    columns = _.reduce(this.orderedColumns, (res, column) => {
                        if (this.visibleColumns.includes(column)) {
                            res.push(column)
                        }
                        return res
                    }, [])

                submit({slug: this.slug, columns})
                    .then(res => {
                        this.successMessage('Operation successfull')
                        this.$parent.$parent.$emit('update:active', false)
                        this.$emit('table-settings-changed')
                        return res
                    })

              setTimeout(function(){ location.reload(); }, 1000);
            },

            columnLabelByField(field) {
                return _.find(this.allColumns, {field}).label
            },
        },

        computed: {
            ...mapGetters(['allTableColumnsBySlug', 'tableColumnsBySlug', 'tableSettingsBySlug']),

            allColumns() {
                return this.availableColumns.length ? this.availableColumns : this.allTableColumnsBySlug(this.slug)
            },

            userColumns() {
                return this.customColumns.length ? this.customColumns : this.tableColumnsBySlug(this.slug)
            },

            userSettings() {
                return this.tableSettingsBySlug(this.slug)
            }
        }
    }
</script>
